module.exports = __webpack_public_path__ + "img/jxw.8b5c6419.png";